import { useState } from "react";
import { toast } from "sonner";
import { useDeleteRoom } from "@/hooks/useRooms";

export const useRoomDelete = () => {
  const deleteRoomMutation = useDeleteRoom();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleRoomDelete = async (id: string, hotelId: string) => {
    try {
      setIsLoading(true);

      await deleteRoomMutation.mutateAsync({ id, hotelId });

      toast.success("Room deleted successfully!");
    } catch (err) {
      const message = (err as Error).message || "Delete failed";
      setError(message);
      toast.error(message);
      console.error("Error deleting room:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    handleRoomDelete,
    isLoading,
    error,
  };
};
